import { useMemo } from "react";

import { StyledButton } from "./styles";

import { CloseButtonProps } from "./types";
import { CloseIcon, CloseBlackIcon } from "@itchannelplus/assets/icons";
import { useTranslations } from "next-intl";

export const CloseButton = ({
  theme: buttonTheme = "dark",
  className,
  labelPosition = "left",
  ...props
}: CloseButtonProps) => {
  const t = useTranslations("common");

  const IconComponent = useMemo(
    () => (buttonTheme === "light" ? CloseIcon : CloseBlackIcon),
    [buttonTheme],
  );

  return (
    <StyledButton {...props} color={buttonTheme} className={className} labelPosition={labelPosition || "left"}>
      { labelPosition == 'left' && <span>{t("close")}</span>} <IconComponent width={39} height={23} /> { labelPosition == 'right' && <span>{t("close")}</span>}
    </StyledButton>
  );
};
